import { render, staticRenderFns } from "./ConnectionFeeTable.vue?vue&type=template&id=4a48d7ba&scoped=true&"
import script from "./ConnectionFeeTable.vue?vue&type=script&lang=js&"
export * from "./ConnectionFeeTable.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionFeeTable.vue?vue&type=style&index=0&id=4a48d7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48d7ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardTitle,VChip,VCol,VDataTable,VDivider,VProgressLinear})
